<template>
  <v-progress-linear indeterminate :active="loading"></v-progress-linear>

  <div class="mb-2 text-medium-emphasis">
    <template v-for="parent in district?.parents" :key="parent.id">
      <v-btn variant="text" small @click="focusDistrict(parent)" :disabled="loading" class="text-decoration-none">
        {{ parent.name }}
        &gt;
      </v-btn>
    </template>
    <span>{{ district?.name }}</span>
  </div>

  <div class="text-center w-100">
    <DistrictSvg
      :sub-districts="subDistricts"
      :width="district?.width"
      :height="district?.height"
      :image-url="district?.image_url"
      @select="focusDistrict"
    />
  </div>
</template>

<script setup>
  import DistrictSvg from "./DistrictSvg.vue";
  import { createDistrictsChannel } from "../../services/districts-channel";
  import { ref, onMounted } from "vue";

  const districtId = defineModel();
  const district = ref({});
  const subDistricts = ref([]);
  const loading = ref(false);
  const districtsChannel = createDistrictsChannel(districtReceived, focusDistrict);

  function districtReceived(data) {
    if (data.sub_district == true) {
      subDistricts.value.push(data);
      subDistricts.value.sort((a, b) => b.area_sqm - a.area_sqm);
    } else {
      district.value = data;
      districtId.value = data.id;
    }
    loading.value = false;
  }

  function focusDistrict(d = null) {
    loading.value = true;
    subDistricts.value.splice(0, subDistricts.value.length);
    districtsChannel.focus(d?.id);
  }
</script>
